import axiosInstance from './axiosInstance'

export const getCustomerById = (customerId) => {
  return axiosInstance.get(`/customers/${customerId}`)
}

export const getCustomers = (page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc') => {
  return axiosInstance.get(`/customers?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const exportCustomers = ({ search = '', orderByKey = 'company', direction = 'asc' } = {}) => {
  return axiosInstance.get(`/customers/export?search=${search}&orderByKey=${orderByKey}&direction=${direction}`, { responseType: 'blob' })
}

export const createCustomer = (data) => {
  return axiosInstance.post('/customers', data)
}

export const updateCustomer = (customerId, data) => {
  return axiosInstance.put(`/customers/${customerId}`, data)
}

export const deleteCustomer = (customerId) => {
  return axiosInstance.delete(`/customers/${customerId}`)
}

export const getCustomerNoteById = (customerId, noteId) => {
  return axiosInstance.get(`/customers/${customerId}/notes/${noteId}`)
}

export const getCustomerNotes = (customerId, page = 1, limit = 50, search = '', orderByKey = 'createdAt', direction = 'desc') => {
  return axiosInstance.get(`/customers/${customerId}/notes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createCustomerNote = (customerId, data) => {
  return axiosInstance.post(`/customers/${customerId}/notes`, data)
}

export const updateCustomerNote = (customerId, noteId, data) => {
  return axiosInstance.put(`/customers/${customerId}/notes/${noteId}`, data)
}

export const deleteCustomerNote = (customerId, noteId) => {
  return axiosInstance.delete(`/customers/${customerId}/notes/${noteId}`)
}
